import { render, staticRenderFns } from "./labelList.vue?vue&type=template&id=547f9c5b&scoped=true&"
import script from "./labelList.vue?vue&type=script&lang=js&"
export * from "./labelList.vue?vue&type=script&lang=js&"
import style0 from "./labelList.vue?vue&type=style&index=0&id=547f9c5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547f9c5b",
  null
  
)

export default component.exports